import type { EventName } from "@lit/react";
import { MessageInput as MessageInputElement, type MessageInputEventMap as _MessageInputEventMap, } from "@vaadin/message-input/vaadin-message-input.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { MessageInputElement, };
export type MessageInputEventMap = Readonly<{
    onSubmit: EventName<_MessageInputEventMap["submit"]>;
}>;
const events = { onSubmit: "submit" } as MessageInputEventMap;
export type MessageInputProps = WebComponentProps<MessageInputElement, MessageInputEventMap>;
export const MessageInput = createComponent({
    elementClass: MessageInputElement, events, react: React, tagName: "vaadin-message-input"
});
